import React from 'react'
import { BonoboLink } from '@utils/BonoboLink'
import { fontSizes } from '@utils/Typography'
export const MiniBanner = ({ children, ...props }) => {
  return (
    <BonoboLink
      fontSize={fontSizes.body}
      px={[4, 3]}
      py={[3, 2]}
      prependArrow
      to="/support/account/moleskine-studio-name-change/"
      width={['100%', 'auto']}
      bg="#dfe1e3"
      color="#000"
      fontWeight="600"
      alignItems="baseline"
      css={{
        whiteSpace: 'nowrap'
      }}
      {...props}
    >
      {children}
    </BonoboLink>
  )
}
